import {
  GET_LIST_CAMDO,
  GET_LIST_CAMDO_SUCCESS,
  GET_LIST_CAMDO_FAILURE,
  GET_SOTAISANTHANHLY_CAMDO,
  GET_SOTAISANTHANHLY_CAMDO_SUCCESS,
  GET_SOTAISANTHANHLY_CAMDO_FAILURE,
} from "./actionTypes";

export const getListCamDo = (dataSearch) => ({
  type: GET_LIST_CAMDO,
  dataSearch,
});

export const getListCamDoSuccess = (data) => ({
  type: GET_LIST_CAMDO_SUCCESS,
  payload: data,
});

export const getListCamDoFailure = () => ({
  type: GET_LIST_CAMDO_FAILURE,
});

export const getSoTaiSanThanhLyCamDo = () => ({
  type: GET_SOTAISANTHANHLY_CAMDO,
});

export const getSoTaiSanThanhLyCamDoSuccess = (data) => ({
  type: GET_SOTAISANTHANHLY_CAMDO_SUCCESS,
  payload: data,
});

export const getSoTaiSanThanhLyCamDoFailure = () => ({
  type: GET_SOTAISANTHANHLY_CAMDO_FAILURE,
});
